export enum UnitType {
  each = 'Each',
  kg = 'Kg',
  Ton = 'Ton',
  Litre = 'Litre',
  Bushel = 'Bushel',
  Bale = 'Bale',
  Sack = 'Sack',
  Bag = 'Bag',
  Carton = 'Carton',
  Crate = 'Crate',
  Bin = 'Bin',
  Barrel = 'Barrel',
  Flat = 'Flat',
  SquareMeter = 'm²',
  CubicMeter = 'm³',
  Decimeter = 'Decimeter',
}
